import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-watchers-exceeded-limit',
  templateUrl: './watchers-exceeded-limit.component.html',
  styleUrls: ['./watchers-exceeded-limit.component.scss']
})
export class WatchersExceededLimitComponent implements OnInit {

  @Input() page : any
  constructor() { }
 
  ngOnInit(): void { 
    //console.log(this.page)
  }

}
